export const disableChannelSelection = (sensorBasicsForm: any) => {
	let disable = false;
	const currentSelectedChannel = sensorBasicsForm.currentModuleChannels.channelsFree.find(
		(channel: {selected: any}) => channel.selected === sensorBasicsForm.selectedChannel.selected
	);
	if (currentSelectedChannel && sensorBasicsForm.currentModuleChannels.channelsFree.length === 1) {
		disable = currentSelectedChannel.channel_types.length <= 1;
	}
	return disable;
};